<template>
  <div class="doppler-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$f' = f [v / (v ± vs)]$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>波源速度 v_s</label>
            <span class="val">{{ vs.toFixed(1) }} <small>m/s</small></span>
          </div>
          <div class="hud-item orange">
            <label>前方波长 λ'</label>
            <span class="val">{{ lambdaFront.toFixed(2) }} <small>m</small></span>
          </div>
          <div class="hud-item green">
             <label>状态</label>
             <span class="val">{{ vs >= 340 ? '超音速激波' : '频移中' }}</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 波源与动态波阵面 (Dynamic Wavefronts) -->
          <g v-for="w in waveFronts" :key="w.id">
             <circle :cx="w.x" :cy="w.y" :r="w.radius" fill="none" stroke="#0ea5e9" :stroke-width="1.5" :opacity="1 - w.radius/300" />
          </g>

          <!-- 运动波源点 (Moving Source) -->
          <circle :cx="sourceX" cy="120" r="6" fill="#fbbf24" filter="url(#glow-d)" />
          
          <text x="225" y="215" text-anchor="middle" fill="#334155" font-size="10">左右调节速度，观察波纹密度分布</text>
          
          <defs>
             <filter id="glow-d"><feGaussianBlur stdDeviation="3" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：当波源向你运动时，它会追赶自己发出的波，导致波纹被“压缩”，频率升高(变尖锐)。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row items-center gap-6">
              <div class="flex-1">
                 <label class="s-label">调节波源运动速度 (v_s)：{{ vs }} m/s</label>
                 <el-slider v-model="vs" :min="-400" :max="400" size="small"></el-slider>
              </div>
              <div class="btn-group">
                 <el-button type="info" size="mini" plain @click="vs = 0">静止波源</el-button>
              </div>
           </div>
        </div>
        
        <!-- 原子化专享高对比度卡片 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-bell"></i></div>
           <div class="text-content">
             <p><strong>实战物理/宇宙学：</strong>多普勒效应是宇宙的“测速计”。<strong>解惑：</strong>这就是救护车驶来时声音变尖，远去时变沉的原因。<strong>观察：</strong>向右加速，$v_s$ 越大，右侧波纹越密（蓝移），左侧越松（红移）。天文学家正是通过测量星光的“红移”发现整个宇宙都在膨胀。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'DopplerWaveShiftViz',
  data() {
    return {
      vs: 80,
      v_sound: 340,
      sourceX: 225,
      waveFronts: [],
      nextId: 0,
      lastSpawn: 0
    }
  },
  computed: {
    lambdaFront() {
       return (this.v_sound - Math.abs(this.vs)) / (this.v_sound / 20); // Normalized lambda
    }
  },
  mounted() { this.animate(); },
  methods: {
    animate() {
       const now = Date.now();
       if (now - this.lastSpawn > 300) {
          this.waveFronts.push({ id: this.nextId++, x: this.sourceX, y: 120, radius: 0 });
          this.lastSpawn = now;
       }
       
       this.sourceX += this.vs * 0.05;
       if (this.sourceX < 50) this.sourceX = 400;
       if (this.sourceX > 400) this.sourceX = 50;

       this.waveFronts.forEach((w, i) => {
          w.radius += 2.5;
          if (w.radius > 300) this.waveFronts.splice(i, 1);
       });
       this.animFrame = requestAnimationFrame(this.animate);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.doppler-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
